import { useState, useEffect } from 'react'
import Breadcrumb from '../../../components/breadcrumb/index'
import { pay_setting_btn_link } from './btn_link/btn_link'
import Pay_setting_Btn_grp from '../../../components/paymentSetting/international/payment_btn_grp/index'
import Swal from 'sweetalert2'
export default function PaymentSetting_perfectMoney() {

    const title = "Perfect Money Payment"
    const [data, setData] = useState([])
    const [rerender, setRerender] = useState(false)
    
    useEffect(() => {
        // call api
        console.log("render from paypal setting")
    }, [rerender])

    // type means personal =1 or marchent=2 or agent=3
    const perfectMoneySettingUpdate = () => {
        Swal.fire('Update Success!', '', 'success')
        setRerender(!rerender)
        console.log('de')
    }
    const brad = [
        {
            name: "home",
        },
        {
            name: title,
        }
    ]
    return (
        <>
            <div className="container-fluid" >
                <Breadcrumb title={title} brad={brad} />
                <Pay_setting_Btn_grp active_btn="perfect_money" btn_link={pay_setting_btn_link} />

                <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
                    <div className="card-body">
                        <div  className="row justify-content-center ">
                            <div  className="col-md-6 mt-3">
                                <label ><b>select brand</ b></label>
                                <select className="form-control">
                                    <option value="">onhost</option>
                                    <option value="">onhost2</option>

                                </select>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label ><b>Status</ b></label>
                                <select className="form-control">
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label><b>Transaction Fee (%)</b></label>
                                <div  className="input-group mb-3">
                                    <input type="number"  className="form-control " defaultValue="deede" aria-label="apigenerate"/>
                                    <span  className="input-group-text">$  </span>
                                </div>
                            </div>

                            <div  className="col-md-6 mt-3">
                                <label  ><b>Min Amount</ b></label>
                                <input type="number" placeholder="Min Amount" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label  ><b>Max Amount(BDT)</ b></label>
                                <input type="number" placeholder="Max Amount" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label  ><b>Sandbox</ b></label>
                                <select className="form-control">
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label  ><b>Exchange Rate (1 USD = ? BDT)</ b></label>
                                <input type="number" placeholder="Enter Exchenge rate" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label  ><b>Extra Fee (BDT)</ b></label>
                                <input type="number" placeholder="Extra fee" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label  ><b>Client Id</ b></label>
                                <input type="number" placeholder="Enter client Id" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label  ><b>Secret Key</ b></label>
                                <input type="number" placeholder="Enter Secret Id" className="form-control" />
                            </div>

                        </div>
                        <button onClick={() => perfectMoneySettingUpdate()} className="btn  btn-primary btn-sm my-3">Update</button>
                    </div>
                </div>
            </div>

        </>
    )
}